import { Abi } from "viem"

export function isValidAbi(abi: unknown): abi is Abi {
  return Array.isArray(abi) || "length" in (abi as Abi)
}
